import script from "./ReactionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactionBar.vue?vue&type=script&setup=true&lang=js"

import "./ReactionBar.vue?vue&type=style&index=0&id=e995c2f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e995c2f8"]])

export default __exports__